import { Component, Prop, Vue } from 'vue-property-decorator';
import BreadcrumbItemInterface from '@/model/vo/navigation/breadcrumb-item-interface';

@Component
export default class BreadcrumbComponent extends Vue
{
    @Prop()
    private items!: BreadcrumbItemInterface[];

    private get show(): boolean
    {
        if (!this.items)
        {
            return false;
        }

        if (!this.$showTemplate)
        {
            return false;
        }

        return true;
    }
}